import PayOnDeliveryPaymentFooter from './pay-on-delivery-payment-footer';

export default PayOnDeliveryPaymentFooter;
